import type { AxiosInstance } from 'axios';
import { PointApi as V1PointApi, SnsAccountsApi as V1SnsAccountApi } from '../lib';
import { AttendancesApi, AuthApi, CampaignApi, DailyCheckInsApi, NoticesApi, NotificationApi, PointApi, SnsAccountsApi, SuggestionsApi, ViewingApi, UserApi, ExchangesApi } from '@smiledragon-corp/viewup-backend-api';

export class ServiceAPI {
  private _campaign: CampaignApi;
  private _viewing: ViewingApi;
  private _snsAccount: SnsAccountsApi;
  private _auth: AuthApi;
  private _point: PointApi;
  private _attendance: AttendancesApi;
  private _dailyCheckIn: DailyCheckInsApi;
  private _notice: NoticesApi;
  private _notification: NotificationApi;
  private _suggest: SuggestionsApi;
  private _user: UserApi;
  private _exchanges: ExchangesApi;
  
  private _v1SnsAccount: V1SnsAccountApi;
  private _v1Point: V1PointApi;

  constructor(private readonly httpClient: AxiosInstance, basePath?: string) {
    this._attendance = new AttendancesApi(undefined, basePath, httpClient);
    this._dailyCheckIn = new DailyCheckInsApi(undefined, basePath, httpClient);
    this._point = new PointApi(undefined, basePath, httpClient);
    this._campaign = new CampaignApi(undefined, basePath, httpClient);
    this._viewing = new ViewingApi(undefined, basePath, httpClient);
    this._snsAccount = new SnsAccountsApi(undefined, basePath, httpClient);
    this._auth = new AuthApi(undefined, basePath, httpClient);
    this._notice = new NoticesApi(undefined, basePath, httpClient);
    this._notification = new NotificationApi(undefined, basePath, httpClient);
    this._suggest = new SuggestionsApi(undefined, basePath, httpClient);
    this._user = new UserApi(undefined, basePath, httpClient);
    this._exchanges = new ExchangesApi(undefined, basePath, httpClient);

    this._v1SnsAccount = new V1SnsAccountApi(undefined, basePath, httpClient);
    this._v1Point = new V1PointApi(undefined, basePath, httpClient);
  }

  get point() {
    return this._point;
  }

  get attendance() {
    return this._attendance;
  }

  get dailyCheckIn() {
    return this._dailyCheckIn;
  }

  get campaign() {
    return this._campaign;
  }

  get viewing() {
    return this._viewing;
  }

  get snsAccount() {
    return this._snsAccount;
  }

  get auth() {
    return this._auth;
  }

  get notice() {
    return this._notice;
  }

  get notification() {
    return this._notification;
  }

  get suggest() {
    return this._suggest;
  }

  get user() {
    return this._user;
  }
  get exchanges() {
    return this._exchanges;
  }

  get v1SnsAccount() {
    return this._v1SnsAccount;
  }

  get v1Point() {
    return this._v1Point;
  }
}
